module.exports = __webpack_public_path__ + "img/teach1.17c8c709.jpg";